import React from 'react';
import { Card, CardContent, Skeleton, Stack, Box } from '@mui/material';

const WorkflowCardSkeleton: React.FC = () => {
  return (
    <Card>
      <CardContent sx={{ p: 2.25 }}>
        <Stack direction="row" spacing={1.75} alignItems="center">
          <Skeleton variant="rounded" width={40} height={40} />
          <Box sx={{ flex: 1 }}>
            <Skeleton width="55%" height={18} />
            <Skeleton width="28%" height={14} />
          </Box>
          <Skeleton variant="circular" width={20} height={20} />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default WorkflowCardSkeleton;
